class RecentColors {
    static save(color) {
        const now = Date.now();
        const recentMap = new Map();
        const recentArray = this.get();
        recentArray.push({ color, time: now });
        recentArray.forEach((recent) => {
            recentMap.set(recent.color, recent.time);
        });
        const newRecent = [...recentMap.entries()]
            .map(([recentColor, time]) => ({ color: recentColor, time }))
            .sort((ra, rb) => ra.time - rb.time)
            .filter((_, i, arr) => arr.length - i <= 9)
            .reverse();
        localStorage.setItem(this.key, JSON.stringify(newRecent));
    }
    static clear() {
        localStorage.removeItem(this.key);
    }
    static get() {
        const recentRawJson = localStorage.getItem(this.key);
        try {
            const recentArray = JSON.parse(recentRawJson !== null && recentRawJson !== void 0 ? recentRawJson : '[]');
            return recentArray !== null && recentArray !== void 0 ? recentArray : [];
        }
        catch (_a) {
            localStorage.removeItem(this.key);
            return [];
        }
    }
}
RecentColors.key = 'recent_used_color';

export { RecentColors };
//# sourceMappingURL=recent-colors.js.map
